import { queryOptions, useQuery } from '@tanstack/react-query';

import { inventoryApi } from '../api/inventory-api';

import { productStockKey } from './inventory-keys';

export function productStockQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productStockKey(productId),
    queryFn: () => inventoryApi.productStock(productId),
  });
}

/** Members without inventory.read pass `enabled: false` and see no stock. */
export function useProductStock(productId: string, enabled = true) {
  return useQuery({ ...productStockQueryOptions(productId), enabled });
}
